import axiosInstance from "utils/axios";

const getListPawnCar = async (filter) => {
  try {
    const response = await axiosInstance.get("/car-pawn/getListPawnCar", {
      params: filter,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching pawn car list:", error);
    throw error;
  }
};

const getPawnCarById = async (id) => {
  console.log("Fetching pawn car by ID:", id);
  try {
    const response = await axiosInstance.get(
      `/car-pawn/getDetailPawnCarById/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pawn car by ID:", error);
    throw error;
  }
};
const createOrderPawnCar = async (data) => {
  const formData = new FormData();

  formData.append("customer_data", JSON.stringify(data.customer_data));
  formData.append("car_data", JSON.stringify(data.car_data));
  formData.append("order_data", JSON.stringify(data.order_data));
  // if (data.image && data.image.length > 0) {
  //   data.image.forEach((file) => {
  //     formData.append("image", file);
  //   });
  // }

  // แนบรูปภาพบัตรประชาชน (รองรับทั้ง DropZone + WebSocket)
  if (data.image && data.image.length > 0) {
    for (const img of data.image) {
      if (img instanceof File) {
        // กรณี DropZone ส่ง File โดยตรง
        formData.append("image", img);
      } else if (img.file instanceof File) {
        // กรณี object { file: File, url, name }
        formData.append("image", img.file);
      } else if (img.url?.startsWith("data:image")) {
        // กรณีได้ base64 มาจาก WebSocket
        const base64Response = await fetch(img.url);
        const blob = await base64Response.blob();
        const file = new File([blob], img.name || "customer_image.jpg", {
          type: blob.type,
        });
        formData.append("image", file);
      }
    }
  }

  if (data.car_photos && data.car_photos.length > 0) {
    data.car_photos.forEach((file) => {
      formData.append("car_photos", file);
    });
  }
  try {
    const response = await axiosInstance.post(
      "/car-pawn/createPawnCar",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating pawn car:", error);
    throw error;
  }
};

const getDetailPawnCarInterestById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/car-pawn/getDetailPawnCarInterestById/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pawn car interest by ID:", error);
    throw error;
  }
};

const updateStatusToForfeiture = async (order_id) => {
  try {
    const response = await axiosInstance.put(
      `/car-pawn/updateStatusToForfeiture/${order_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error updating status to forfeiture:", error);
    throw error;
  }
};

const updatePawnCarInterest = async (order_id, data) => {
  const formData = new FormData();

  if (data.period && Array.isArray(data.period) && data.period.length > 0) {
    if (data.period.length === 1) {
      //แค่ 1 อัน => ส่งเป็น string
      formData.append("period", JSON.stringify(data.period[0]));
    } else {
      //หลายอัน => ส่ง array ของ string
      data.period.forEach((item) => {
        formData.append("period", JSON.stringify(item));
      });
    }
  }

  if (data.slip && Array.isArray(data.slip) && data.slip.length > 0) {
    data.slip.forEach((file) => {
      if (file instanceof File) {
        formData.append("slip", file);
      } else if (file?.file instanceof File) {
        formData.append("slip", file.file);
      }
    });
  }
  formData.append("description", data.description || "");
  formData.append("total_payment", data.total_payment || 0);

  try {
    const response = await axiosInstance.put(
      `/car-pawn/updatePawnCarInterest/${order_id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating pawn car interest:", error);
    throw error;
  }
};

const getDetailPawnCarRedeemById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/car-pawn/getDetailPawnCarRedeemById/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching pawn car redeem by ID:", error);
    throw error;
  }
};

const updatePawnCarRedeem = async (order_id, data) => {
  const formData = new FormData();

  if (data.slip && Array.isArray(data.slip) && data.slip.length > 0) {
    data.slip.forEach((file) => {
      if (file instanceof File) {
        formData.append("slip", file);
      } else if (file?.file instanceof File) {
        formData.append("slip", file.file);
      }
    });
  }
  formData.append("description", data.description || "");
  formData.append("penalty", data.penalty || 0);
  if (data.period && Array.isArray(data.period) && data.period.length > 0) {
    if (data.period.length === 1) {
      formData.append("period", JSON.stringify(data.period[0]));
    } else {
      data.period.forEach((item) => {
        formData.append("period", JSON.stringify(item));
      });
    }
  }
  formData.append("payment_method", data.payment_method || "");
  formData.append("total_payment", data.total_payment || 0);

  try {
    const response = await axiosInstance.put(
      `/car-pawn/updatePawnCarRedeem/${order_id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating pawn car redeem:", error);
    throw error;
  }
};

// Redeem Car
const getListRedeemCars = async (filter) => {
  try {
    const response = await axiosInstance.get("/car-redeem/getListRedeemCar", {
      params: filter,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching redeem car list:", error);
    throw error;
  }
};

const getRedeemCarById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `/car-redeem/getDetailRedeemCarById/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching redeem car by ID:", error);
    throw error;
  }
};

const getRepossessedCars = async (filter) => {
  try {
    const response = await axiosInstance.get(
      "/car-pawn-forfeiture/getListPawnForfeitureCar",
      {
        params: filter,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching repossessed car list:", error);
    throw error;
  }
};

const getRepossessedCarById = async (car_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-pawn-forfeiture/getDetailPawnForfeitureCarById/${car_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching repossessed car by ID:", error);
    throw error;
  }
};

const createCarPawnContact = async (data, order_id) => {
  try {
    const response = await axiosInstance.post(
      `/car-pawn/createCarPawnContact/${order_id}`,
      { ...data }, // ✅ ส่ง JSON ตรง ๆ
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating car pawn contact:", error);
    throw error;
  }
};

const updateCarPawnContact = async (data, document_id) => {
  try {
    const response = await axiosInstance.put(
      `/car-pawn/updateCarPawnContact/${document_id}`,
      { ...data }, // ✅ ส่ง JSON ตรง ๆ
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating car pawn contact:", error);
    throw error;
  }
};

const getDetailCarPawnContactById = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-pawn/getDetailCarPawnContactById/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching car pawn contact by ID:", error);
    throw error;
  }
};

const printPdfCarPawnContact = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-pawn/printPdfCarPawnContact/${document_id}`,
      {
        responseType: "blob", // important
      }
    );
    return response;
  } catch (error) {
    console.error("Error printing PDF car pawn contact:", error);
    throw error;
  }
};

const createTransferAndReceiptPawn = async (order_id, data) => {
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));

    const response = await axiosInstance.post(
      `/car-pawn/createCarTransformContact/${order_id}`,
      formData, // ✅ ส่ง JSON ตรง ๆ
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating transfer and receipt pawn:", error);
    throw error;
  }
};

const getTransferAndReceiptPawnByID = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-pawn/getDetailCarTransformContactById/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching transfer and receipt pawn by ID:", error);
    throw error;
  }
};

const updateTransformAndReceiptPawn = async (data, document_id) => {
  try {
    const formData = new FormData();
    formData.append("doc_data", JSON.stringify(data));
    const response = await axiosInstance.put(
      `/car-pawn/updateCarTransformContact/${document_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating transfer and receipt:", error);
    throw error;
  }
};

const printPdfCarTransferPawn = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-pawn/printPdfCarTransformContact/${document_id}`,
      {
        responseType: "blob", // important
      }
    );
    return response;
  } catch (error) {
    console.error("Error printing PDF car transfer pawn:", error);
    throw error;
  }
};

const createPowerOfAttorneyPawn = async (order_id, data) => {
  try {
    const response = await axiosInstance.post(
      `/car-pawn/createCarPowerOfAttorney/${order_id}`,
      { ...data },
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating power of attorney document:", error);
    throw error;
  }
};

const getPowerOfAttorneyPawnByID = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-pawn/getDetailCarPowerOfAttorneyById/${document_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching power of attorney by ID:", error);
    throw error;
  }
};

const printPdfPowerOfAttorneyPawn = async (document_id) => {
  try {
    const response = await axiosInstance.get(
      `/car-pawn/printPdfCarPowerOfAttorney/${document_id}`,
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    console.error("Error printing PDF power of attorney:", error);
    throw error;
  }
};

const updatePowerOfAttorneyPawn = async (document_id, data) => {
  try {
    const formData = new FormData();
    formData.append("doc_data", JSON.stringify(data));
    const response = await axiosInstance.put(
      `/car-pawn/updateCarPowerOfAttorney/${document_id}`,
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating power of attorney document:", error);
    throw error;
  }
};

const PawnCarService = {
  getListPawnCar,
  getPawnCarById,
  createOrderPawnCar,
  getDetailPawnCarInterestById,
  updatePawnCarInterest,
  getDetailPawnCarRedeemById,
  updatePawnCarRedeem,
  getListRedeemCars,
  getRedeemCarById,
  getRepossessedCars,
  getRepossessedCarById,
  updateStatusToForfeiture,
  createCarPawnContact,
  updateCarPawnContact,
  getDetailCarPawnContactById,
  printPdfCarPawnContact,
  createTransferAndReceiptPawn,
  getTransferAndReceiptPawnByID,
  updateTransformAndReceiptPawn,
  printPdfCarTransferPawn,
  createPowerOfAttorneyPawn,
  getPowerOfAttorneyPawnByID,
  printPdfPowerOfAttorneyPawn,
  updatePowerOfAttorneyPawn,
};
export default PawnCarService;
